import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface CustomSelectNativeProps {
	noBlank?: boolean;
	options: { disabled?: boolean; value: string | number; label: string }[];
	placeholder?: string;
}
const SelectNative: React.FC<CustomSelectNativeProps & React.ComponentProps<typeof TextField>> = ({
	noBlank,
	options,
	placeholder,
	...otherProps
}) => {
	const { t } = useTranslation("common");
	return (
		<TextField fullWidth={true} select {...otherProps}>
			{placeholder !== undefined && (
				<MenuItem disabled value="">
					{placeholder}
				</MenuItem>
			)}
			{noBlank !== true && <MenuItem value="">{t("selectNative.none")}</MenuItem>}
			{options.map((option) => (
				<MenuItem disabled={option.disabled} key={option.value} value={option.value}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};

export default SelectNative;
